import React from 'react';
import { takeLatest, put, call, select, debounce } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import SVG from 'react-inlinesvg';
import { checkCircleSVG } from '../../shared/helpers/icons';
import styles from '../../shared/styles/notifications.module.scss';
import {
    GET_USERS_REQUEST,
    GET_TYPING_USERS_REQUEST,
    getUsersSuccess,
    getUsersFailure,
    SUBMIT_USER_REQUEST,
    submitUsersSuccess,
    submitUsersFailure,
    getUsersRequest,
    UPDATE_USER_REQUEST,
    updateUserSuccess,
    updateUserFailure
} from '../actions/users';
import { getUsers, postUsers, putUsers } from '../services/users';
import { getProfileInstallerID, getProfilesWorker } from '../../profiles/sagas/profiles';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import { profilesAccessor } from '../../profiles/selectors/profiles';
import { defaultPath } from '../routes';

export const getUsersWorker = function* ({ payload: { filters, page } }) {
    try {
        yield call(getProfilesWorker);

        if (filters.getOnlyUsersInstaller) {
            filters.profile = yield call(getProfileInstallerID);
            delete filters.getOnlyUsersInstaller;
        }

        const token = yield select(accessTokenSelector);
        const { profiles } = yield select(profilesAccessor);

        const {
            data: { users, total }
        } = yield call(getUsers, filters, token);

        yield put(getUsersSuccess(users, total, profiles, page));
    } catch (err) {
        yield put(getUsersFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const updateUserWorker = function* ({ payload: { user } }) {
    try {
        const token = yield select(accessTokenSelector);

        if (!user || !user._id) {
            throw new Error('Missing user._id for update');
        }

        const { data } = yield call(putUsers, user, token);
        yield put(updateUserSuccess(data));

        toast.success(
            <div className={styles.customToastSuccess}>
                <div className={styles.toastContent}>
                    <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                    Usuario editado con éxito
                </div>
            </div>,
            {
                className: styles.toast,
                toastId: `user-updated-${user._id}-${Date.now()}`
            }
        );
    } catch (err) {
        yield put(updateUserFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const submitUsersWorker = function* ({ payload: { user }, history }) {
    try {
        const token = yield select(accessTokenSelector);

        if (!user._id) {
            yield call(postUsers, user, token);
           
            toast.success(
                <div className={styles.customToastSuccess}>
                    <div className={styles.toastContent}>
                        <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                        Usuario creado con éxito
                    </div>
                </div>,
                {
                    className: styles.toast,
                    toastId: `user-created-${Date.now()}`
                }
            );
        } else {
            yield call(putUsers, user, token);
            toast.success(
                <div className={styles.customToastSuccess}>
                    <div className={styles.toastContent}>
                        <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                        Usuario editado con éxito
                    </div>
                </div>,
                {
                    className: styles.toast,
                    toastId: `user-created-${Date.now()}`
                }
            );
        }

        yield put(getUsersRequest({}));
       
        if (history && history.push) {
            history.push(defaultPath);
        }
    } catch (err) {
        if (err && err.response && err.response.status && err.response.status === 409) {
            yield put(showGlobalError(true, 409, 'user_already_exist'));
        } else {
            yield put(showGlobalError(true, 500, 'Ha ocurrido un error'));
        }
        // yield put(submitUsersFailure(err));
    }
};

export default [
    takeLatest(GET_USERS_REQUEST, getUsersWorker),
    takeLatest(SUBMIT_USER_REQUEST, submitUsersWorker),
    takeLatest(UPDATE_USER_REQUEST, updateUserWorker),
    debounce(500, GET_TYPING_USERS_REQUEST, getUsersWorker)
];
